import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import Helmet from 'react-helmet';
import { Container, Row, Col, Card, CardImgOverlay, CardHeader, CardTitle, CardBody, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import FontCustom from '../../../../components/Content/FontCustom';

import config from '../../../../config';

import { getContentBlockItemByName, getContentBlockMixedItem } from '../../../Cms/CmsActions';

import ContactForm from '../../components/form/ContactForm';

import Breadcrumbs from '../../../App/components/view/Breadcrumbs';
import HtmlComponent from '../../../../components/Text/HtmlComponent';
import FileLoader from '../../../../components/Content/FileLoader';

import AppContact from '../../../App/components/AppContact';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';

function ContactPage({ page }) {
    const image = getContentBlockItemByName(page.blocks, 'image');
    const title = getContentBlockItemByName(page.blocks, 'title');
    const content = getContentBlockItemByName(page.blocks, 'content');
    const promotion = getContentBlockItemByName(page.blocks, 'promotion');
    return (
        <Container>
            <Card>
                {image && <FileLoader filename={image.path} loadonmount className="card-img" style={{ minHeight: '200px' }} />}
                <CardImgOverlay>
                    <Breadcrumbs crumb={page && page.title} />
                </CardImgOverlay>
            </Card>
            <div className={classnames(image && 'override-block-lg')}>
                <Row>
                    <Col xs="12" md="8">
                        {title && <h1 className="pb-3 text-dark font-weight-bold">{title.text}</h1>}
                        {content && <HtmlComponent text={content.text} />}
                        <ContactForm />
                    </Col>
                    <Col>
                        <div className="d-none d-md-block bg-tertiary text-center" style={{ paddingTop: '110px' }}>
                            {getContentBlockMixedItem(promotion, 'image') && (
                                <div className="d-none d-md-block position-absolute w-100" style={{ top: '-350px', left: 0 }}>
                                    <CmsBlockItem item={getContentBlockMixedItem(promotion, 'image')} type="image" className="w-75" />
                                </div>
                            )}
                            <div className="p-3">
                                {getContentBlockMixedItem(promotion, 'title') && <span className="h5 font-weight-bold">{getContentBlockMixedItem(promotion, 'title').text}</span>}
                                {getContentBlockMixedItem(promotion, 'call-to-action') && (
                                    <Button color="light" block tag={Link} to={getContentBlockMixedItem(promotion, 'call-to-action').path} className="mt-3">{getContentBlockMixedItem(promotion, 'call-to-action').text}</Button>
                                )}
                            </div>
                        </div>
                        <div className="d-block d-md-none p-3 bg-tertiary text-center">
                            <div className="text-center"><CmsBlockItem item={getContentBlockMixedItem(promotion, 'image')} type="image" className="mb-3 w-75" /></div>
                            {getContentBlockMixedItem(promotion, 'title') && <span className="h5 font-weight-bold">{getContentBlockMixedItem(promotion, 'title').text}</span>}
                            {getContentBlockMixedItem(promotion, 'call-to-action') && (
                                <Button color="light" block tag={Link} to={getContentBlockMixedItem(promotion, 'call-to-action').path} className="mt-3">{getContentBlockMixedItem(promotion, 'call-to-action').text}</Button>
                            )}
                        </div>
                        <AppContact hideEmail />
                        {/*
                            <div className=" bg-quaternary">
                                <Row noGuuters>
                                <Col xs="3" className="text-center">
                                    <FontCustom name="contact" size="4.5" />
                                </Col>
                                <Col>
                                    <span className="h1"><FormattedMessage id="contactTitle" defaultMessage="Contact" /></span>
                                    <p className="text-primary">
                                        <FormattedMessage id="contactInfoText" defaultMessage="For any questions on product or your order" />
                                    </p>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-center font-weight-bold text-lg special-font">
                                <a href={`tel:${config.application.phone}`} className={classnames('text-white')}>{config.application.phone}</a>
                            </div>
                        </div>
                    */}
                    </Col>
                </Row>
            </div>
        </Container>
    );
}

ContactPage.propTypes = {
    page: PropTypes.object.isRequired,
};

export default ContactPage;


export const ContactPageModel = {
    type: 'page',
    name: 'contact',
    slug: 'contact',
    blocks: [
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'content', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
        },
        {
            name: 'promotion',
            type: 'mixed',
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
            ],
        },
    ],
};
